export default __webpack_public_path__ + "static/media/purifyinglight.e77b5a32.png";